import $ from 'jquery';
import { Component } from '@mycolorway/tao';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import currentMember from 'next/javascripts/modules/current-memebr';
import resourceSubject from 'next/javascripts/reactivity/resource-subject';

import 'next/stylesheets/components/todo-page/main';

function parseDate(dates) {
  let startAt;
  let dueAt;

  if (dates.length === 2) {
    [startAt, dueAt] = dates;
  } else {
    startAt = null;
    [dueAt] = dates;
  }

  return [startAt, dueAt];
}

Component('tr-todo-page-main', {
  mixins: [eventListenerMixin],

  properties: {
    guid: String,
    editUrl: String,
    completeUrl: String,
    reopenUrl: String,
  },

  connected() {
    this.listenTo(this, {
      'tr-checkbox-field:change': this.handleCheckboxChange.bind(this),
      'tr-todo-assignee-select-field:change': this.handleAssigneeChange.bind(this),
      'tr-todo-date-field:change': this.handleDateChange.bind(this),
      'tr-todo-priority-field:change': this.handlePriorityChange.bind(this),
    });

    this.todoSubscription = resourceSubject('todo').subscribe({
      next: (event, payload) => {
        if (!payload.guid
          || payload.guid !== this.guid || payload.from !== 'grid') return;

        if (event === 'update' && payload.is_completed != null) {
          const checkbox = this.querySelector('.main-todo-checkbox');
          checkbox.checked = payload.is_completed;
        }
      },
    });
  },

  handleCheckboxChange(event) {
    event.stopPropagation();
    this.toggleCompletionStatus(event.detail.checked);
  },

  handleAssigneeChange(event) {
    event.stopPropagation();
    const assigneeGuid = event.detail;
    if (assigneeGuid === null) return;

    this.update({ assignee_guid: assigneeGuid })
      .then((todo) => {
        this.namespacedTrigger('assigneeChange', {
          detail: { todo },
          bubbles: true,
        });
      });
  },

  handleDateChange(event) {
    event.stopPropagation();
    const data = { start_at: null, due_at: null };
    const addition = this.querySelector('.addition.due-date');

    if (event.detail.length) {
      addition.classList.add('has-due-date');

      const [startAt, dueAt] = parseDate(event.detail.split(','));
      data.start_at = startAt;
      data.due_at = dueAt;
    } else {
      addition.classList.remove('has-due-date');
    }

    this.update(data)
      .then((todo) => {
        this.namespacedTrigger('dateChange', {
          detail: { todo },
          bubbles: true,
        });
      });
  },

  handlePriorityChange(event) {
    event.stopPropagation();
    this.update({ priority: event.detail })
      .then((todo) => {
        this.namespacedTrigger('priorityChange', {
          detail: { todo },
          bubbles: true,
        });
      });
  },

  async assignToCurrentMember() {
    const member = await currentMember;
    const field = this.querySelector('tr-todo-assignee-select-field');
    if (field) {
      field.setValue(member.guid);
    } else {
      const assignee = this.querySelector('.assignee');
      assignee.classList.remove('no-assignee');
      assignee.querySelector('.addition-avatar').src = member.avatar;
      assignee.querySelector('.addition-content.has-assignee').innerText = member.nickname;
    }
  },

  toggleCompletionStatus(completed) {
    if (completed) this.classList.remove('running');

    if (!this.completeUrl && !this.reopenUrl) {
      this.namespacedTrigger(completed ? 'complete' : 'reopen', { bubbles: true });
      return;
    }

    $.ajax({
      url: completed ? this.completeUrl : this.reopenUrl,
      type: 'post',
      dataType: 'script',
    }).then(() => {
      this.namespacedTrigger(completed ? 'complete' : 'reopen', { bubbles: true });
    });
  },

  update(data) {
    if (this.editUrl) {
      return $.ajax({
        url: this.editUrl,
        type: 'patch',
        dataType: 'json',
        data: {
          todos_management: data,
        },
      });
    }

    return new Promise(resolve => resolve(data));
  },

  disconnected() {
    this.stopListening();
    if (this.todoSubscription) this.todoSubscription.unsubscribe();
  },
});
